export const ProductViews = {
    grid: 'grid',
    list: 'list'
}